export default {
      id: "close_small-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#close_small",
      toString: function () {
        return this.url;
      }
    }